import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import PlaySvg from '../../svg/Play';
import Mission1 from './new4tasks/Mission1';
import Mission2 from './new4tasks/Mission2';
import Mission3 from './new4tasks/Mission3';
import Mission4 from './new4tasks/Mission4';

const TASKS = [
  {
    id: 1,
    photo: '/閱讀策略/1.png',
    name: '策略1：找有關的顯性訊息',
    subtitle: '閱讀策略 1'
  },
  {
    id: 2,
    photo: '/閱讀策略/2.png',
    name: '策略2：推論超連結是否有用',
    subtitle: '閱讀策略 2'
  },
  {
    id: 3,
    photo: '/閱讀策略/3.png',
    name: '策略3：歸納來自相同或不同網頁的訊息',
    subtitle: '閱讀策略 3'
  },
  {
    id: 4,
    photo: '/閱讀策略/4.png',
    name: '策略4：判斷網站上訊息是否可靠',
    subtitle: '閱讀策略 4'
  }
]
function Component(props) {
  const { } = useParams();
  const navigate = useNavigate();
  const [data, setdata] = useState(null)
  const [isLoading, setisLoading] = useState(false)
  const [mission, setMission] = useState(null)



  const isMobile = window.innerWidth < 1024

  if (mission?.id === 1)
    return (
      <Mission1 onClose={() => setMission(null)} />
    )
  if (mission?.id === 2)
    return (
      <Mission2 onClose={() => setMission(null)} />
    )
  if (mission?.id === 3)
    return (
      <Mission3 onClose={() => setMission(null)} />
    )
  if (mission?.id === 4)
    return (
      <Mission4 onClose={() => setMission(null)} />
    )

  return (
    <div className='flex-[1] flex flex-col h-full' style={{ overflowY: "auto", gap: isMobile ? '8px' : '16px', padding: isMobile ? '8px' : '16px' }}>


      {/*button to redirect to practice page*/}
      <div className='w-full flex flex-row gap-[12px]'>
        <div className='flex flex-row gap-[8px] items-center justify-start items-center cursor-pointer' onClick={
          () => {
            navigate(-1)
          }
        }>
          <div className='text-[#214BFF] font-[700]' style={{ fontSize: '2rem' }}>返回</div>
        </div>

      </div>
      {/*end of button*/}

      {/*description section*/}
      <div className='flex flex-col w-full text-[1.5rem]' style={{ textAlign: 'justify' }}>
        在線上閱讀找自己感興趣的話題、學習或做研究探索等，困難還真不少呢！因為網上的內容常常是跳來跳去的，一按連結就會轉到其他頁面，而且畫面上還有許多圖片、影片或其他吸引人的資訊，很容易讓人分心；不像看書那樣，可以一頁一頁慢慢看。有些重要資料還藏在連結裏，不容易一下子找到。
        <br /><br />
        網上也可能有不正確或虛假的內容，我們需要小心分辨。不過大家不用擔心，只要按部就班，學會以下四個線上閱讀策略，你也能成為線上閱讀小達人！
      </div>



      <div className='flex flex-row gap-[16px] w-full flex-wrap' style={{}}>
        {TASKS?.map((item, index) =>
          <div key={item?._id || index} className='rounded-[20px] bg-[white] flex flex-col cursor-pointer hover:opacity-[.8]' style={{
            overflow: 'hidden', height: isMobile ? 300 / 3 * 2 : 300, width: isMobile ? 550 / 3 * 2 : 550,
          }}
            onClick={() => {
              setMission(item)
            }}>
            <img src={item?.photo} className='w-full rounded-[20px]' style={{ height: isMobile ? 205 / 3 * 2 : 205, objectFit: 'cover' }} />
            <div className='flex flex-row w-full'>
              <div className='flex flex-col flex-1'>
                <div className='flex flex-row w-full items-end text-[#43528A] flex-wrap' style={{ paddingLeft: isMobile ? 8 : 16, paddingRight: isMobile ? 8 : 16, gap: isMobile ? 4 : 16, paddingTop: isMobile ? 2 : 8 }}>
                  <div className='text-[#43528A] font-[700]' style={{ fontSize: isMobile ? 14 : 24 }}>{item?.name}</div>
                </div>
                <div className='mt-[2px] flex flex-row w-full items-end text-[#43528A] flex-wrap' style={{ paddingLeft: isMobile ? 8 : 16, paddingRight: isMobile ? 4 : 16, gap: isMobile ? 8 : 16 }}>
                  <div className='' style={{ fontSize: isMobile ? 12 : 18 }}>{item.subtitle}</div>
                </div>
              </div>
              <div className='h-full flex flex-row items-center' style={{ padding: isMobile ? 4 : 16 }}>
                <PlaySvg width={isMobile ? 28 : 44} />
              </div>
            </div>
          </div>
        )}
      </div>
      {/*end of missions*/}

      {isLoading && <LoadingPage />}
    </div>
  );
}

function Mission_One(props) {
  const handleWrongAnswer = (e) => {
    e.preventDefault();
    alert('答錯了，請再試一次！');
  }
  const [showAnswer1Popup, setShowAnswer1Popup] = useState(false);
  const [showAnswer2Popup, setShowAnswer2Popup] = useState(false);

  return (
    <div className='flex-[1] flex flex-col h-full w-full justify-start items-center' style={{ overflowY: "auto", gap: '16px', padding: '16px' }}>
      <div className='text-[2rem] font-bold max-w-[1200px]'> 策略1：找有關的顯性訊息 </div>
      <div className='text-[1.5rem] w-full flex flex-col whitespace-pre-line max-w-[1200px] items-center' style={{ textAlign: 'justify' }}>
        假設有人問你：動物是怎麼散熱的？如果你不知道答案，是不是會上網查找呢？在網上查找，會有一些「顯性信息」。所謂的「顯性信息」，就是答案「清清楚楚」出現在畫面上。有時候，這些訊息是在圖片、圖表或影片裏。
        <br />
        <br />
        怎麼找呢？兩步教你輕鬆達標：
        <br />
        <br />
        <img src='/閱讀策略/task1-00.jpg' alt='task1-01' className='max-w-[800px] w-full' style={{ objectFit: 'contain' }} />
        <br />
        【學一學】
        <br />
        <div><mark>貓</mark>的汗腺主要在腳掌，用來<mark>散熱</mark>。因此，在夏天來臨時，建議剪掉貓的腳掌上較長的毛髮，但不能剪光全部的毛髮，因為這會使牠們受到病菌的傷害。</div>
        <br /><br />

        <div className='text-center'>
          <img src='/閱讀策略/task1-01.png' alt='task1-01' className='max-w-[400px] w-full' style={{ objectFit: 'contain' }} />
          圖1 <mark>修剪貓的毛髮</mark>
        </div>
        <br />
        <br />
        黃色標示的文字和圖片，就是跟主題詞「小貓」和「散熱」有關了，找到後仔細閱讀，理解圖意，把兩者結合起來，就能找到答案。
        <br />
        <br />
        答案：原來，小貓散熱是靠它的腳掌上的汗腺。剪掉腳掌上較長的毛髮，就可以幫助小貓散熱了！
        <br />
        <br />
        有時候，上網找資料時，答案不只寫在文字裏，還會藏在圖片或圖表中。小朋友都愛吃零食，特別是巧克力。可是，每日吃多少才合適呢？想知答案，就上網找出營養師建議每日吃黑巧克力的份量吧！
        <br />
        <br />

        <div className='text-center'>
          <img src='/閱讀策略/task1-02.png' alt='task1-01' className='max-w-[1000px] w-full' style={{ objectFit: 'contain' }} />
        </div>
        <br /><br />
        找出「黑巧克力」和「每日份量」這兩個關鍵字，再細看圖表裏的數字和說明，就能找到答案。
        <br /><br />
        答案：營養師建議每日約吃3-5小片黑巧克力，你做對了嗎？
        <br /><br />
        <br /><br />

        【練一練】
        <br /><br />
        同學們，學會了「找有關的顯性訊息」策略後，現在輪到你們試一試啦！

        <br /><br />
        大象的祖先猛瑪象生活在寒冷的環境中，身上長滿毛髮來讓自己暖和。現在大象身體的毛髮數量減少，能防止身體温度過高。大象的血液流過牠的耳朵時會散熱，再加上搖擺耳朵的動作，血液的温度就會降低。通常大象耳朵越大，散熱效果越好。


        <div className='text-center'>
          <img src='/閱讀策略/task1-03.png' alt='task1-01' className='max-w-[400px] w-full' style={{ objectFit: 'contain' }} />
          圖1 大象的祖先猛瑪象
        </div>

        <br />
        <div className='w-full'>
          1.	猛瑪象身體的毛髮有甚麼作用？
        </div>
        <div className='w-full text-left'>
          <input type='radio' onClick={handleWrongAnswer} ></input> A.	走路加快
        </div>
        <div className='w-full text-left'>
          <input type='radio' onClick={(e) => { e.preventDefault(); setShowAnswer1Popup(true) }} ></input> B.	保持暖和
        </div>
        <div className='w-full text-left'>
          <input type='radio' onClick={handleWrongAnswer}></input> C.	減少吃飯
        </div>
        <br />

        {showAnswer1Popup && (
          <div className='w-full h-full absolute inset-0 bg-[#00000080] p-4 flex items-center justify-center'>
            <div className='bg-white p-4 rounded flex flex-col'>
              答案：保持暖和
              <br />
              解析： 根據題目關鍵字「猛瑪象的毛髮」、「作用」，定位文章第一句「身上長滿毛髮來讓自己暖和」，即可選出答案 B。

              <button onClick={() => setShowAnswer1Popup(false)} className='mt-4 bg-blue-500 text-white p-2 rounded'>關閉</button>
            </div>
          </div>
        )}
        <br />
        <br /><br />
        <div className='w-full'>
          2.	京劇臉譜中的「金、銀」色通常用來表現哪一類角色的形象？
        </div>
        <div className='w-full text-left'>
          <input type='radio' onClick={handleWrongAnswer} ></input> A.	鐵面無私
        </div>
        <div className='w-full text-left'>
          <input type='radio' onClick={(e) => { e.preventDefault(); setShowAnswer2Popup(true) }} ></input> B.	神佛
        </div>
        <div className='w-full text-left'>
          <input type='radio' onClick={handleWrongAnswer}></input> C.	忠烈
        </div>

        <br /><br />

        <table border="1" className='w-full' style={{ border: '1px solid black' }}>
          <tr style={{ borderBottom: '1px solid black' }}>
            <th>角色</th>
            <th>圖例</th>
            <th>説明</th>
          </tr>
          <tr style={{ borderBottom: '1px solid black' }}>
            <td>黑色</td>
            <td>
              <img src='/閱讀策略/task1-04.png' alt='法海' className='max-w-[100px] w-full' style={{ objectFit: 'contain' }} />
              法海
            </td>
            <td>普遍表現人物鐵面無私與剛直的形象</td>
          </tr>
          <tr style={{ borderBottom: '1px solid black' }}>
            <td>金、銀</td>
            <td>
              <img src='/閱讀策略/task1-05.png' alt='黑虎趙靈官' className='max-w-[100px] w-full' style={{ objectFit: 'contain' }} />
              黑虎趙靈官
            </td>
            <td>普遍為神佛，象徵其金身不滅</td>
          </tr>
          <tr style={{ borderBottom: '1px solid black' }}>
            <td>紅色</td>
            <td>
              <img src='/閱讀策略/task1-06.png' alt='二郎神' className='max-w-[100px] w-full' style={{ objectFit: 'contain' }} />
              二郎神
            </td>
            <td>普遍表現人物忠烈的形象</td>
          </tr>
        </table>

        <br />

        <br />

        {showAnswer2Popup && (
          <div className='w-full h-full absolute inset-0 bg-[#00000080] p-4 flex items-center justify-center'>
            <div className='bg-white p-4 rounded flex flex-col'>
              答案：B
              <br />
              解析：根據題目關鍵字「金、銀」，定位表格第二行，說明欄明確寫著「普遍為神佛」，所以答案是 B。

              <button onClick={() => setShowAnswer2Popup(false)} className='mt-4 bg-blue-500 text-white p-2 rounded'>關閉</button>
            </div>
          </div>
        )}

      </div>

      {/* return button*/}
      <button onClick={props.onClose} className='my-[24px] bg-blue-500 text-white p-2 px-[16px] rounded'>返回</button>
    </div>
  )
}
function Mission_Two(props) {
  const handleWrongAnswer = (e) => {
    e.preventDefault();
    alert('答錯了，請再試一次！');
  }
  const [showAnswer1Popup, setShowAnswer1Popup] = useState(false);
  const [showAnswer2Popup, setShowAnswer2Popup] = useState(false);

  return (
    <div className='flex-[1] flex flex-col h-full w-full justify-start items-center' style={{ overflowY: "auto", gap: '16px', padding: '16px' }}>
      <div className='text-[2rem] font-bold max-w-[1200px]'> 策略2：推論超連結是否有用  </div>
      <div className='text-[1.5rem] w-full flex flex-col whitespace-pre-line max-w-[1200px] items-center' style={{ textAlign: 'justify' }}>
        線上閱讀跟紙本閱讀最大的不同，在於我們需要「先預測、後點擊」。這就像在猜謎一樣：你要的答案，會在這裏面嗎？網頁上的超連結(藍色字或按鈕)就像路牌，點擊前，先讀一讀那幾個字，想想它背後代表甚麼主題。<br />
        <br />
        怎麼學？兩步教你「超前預測」：
        <br />
        <br />
        <img src='/閱讀策略/task2-00.jpg' alt='task1-01' className='max-w-[800px] w-full' style={{ objectFit: 'contain' }} />
        <br />
        <div className='w-full'>【學一學】</div>
        <div className='w-full'>除了小寵物外，你會不會也想知道其他動物是怎麼散熱的呢？如果想知道大象的散熱方法，應該點擊哪一個超連結？</div>
        <br /><br />
        <div className='flex flex-col gap-2 w-full text-left'>
          <div className='flex flex-row'>
            A.	超連結一︰<div className='text-blue-500 underline cursor-pointer'>大象降温方法大公開</div>
          </div>

          <div className='flex flex-row'>
            B.	超連結二︰<div className='text-blue-500 underline cursor-pointer'>大象每天最愛吃甚麼</div>
          </div>

          <div className='flex flex-row'>
            C.	超連結三︰<div className='text-blue-500 underline cursor-pointer'>大象共有多少個品種</div>
          </div>

          <div className='flex flex-row'>
            D.	超連結四︰<div className='text-blue-500 underline cursor-pointer'>大象的生活習慣</div>
          </div>
        </div>
        <br />
        黃色標示的詞語哪個與散熱有關呢？把想找的目標「散熱方法」跟各選項的關鍵字進行「聯想」：散熱就是讓身體熱氣散走，讓身體降温，跟選項A對應；其他選項 (吃甚麼、品種、生活習慣) 都跟「散熱方法」無關。
        <br />
        <br />

        <div className='text-center'>
          <img src='/閱讀策略/task2-01.jpg' alt='task1-01' className='max-w-[1000px] w-full' style={{ objectFit: 'contain' }} />
        </div>
        <br /><br />

        
        <div className='w-full'>【練一練】</div>
        <div className='w-full'>
        同學們，學會了「推論超連結是否有用」策略後，現在輪到你們試一試啦！
        </div>
        <br />
        <div className='w-full'>
           1.	小美明天會到香港迪士尼樂園遊玩，她想先找出「小小世界」在哪裏。以下哪一個超連結最有用？ 
        </div>
        <div className='w-full text-left flex flex-row'>
          <input type='radio'  className='mr-[8px]' onClick={handleWrongAnswer} ></input>  A.	超連結一︰<div className='text-blue-500 underline cursor-pointer' onClick={handleWrongAnswer}>餐飲推薦</div>
        </div>
        <div className='w-full text-left flex flex-row'>
          <input type='radio'  className='mr-[8px]' onClick={handleWrongAnswer} ></input>  B.	超連結二︰<div className='text-blue-500 underline cursor-pointer' onClick={handleWrongAnswer}>樂園表演時間表</div>
        </div>
        <div className='w-full text-left flex flex-row'>
          <input type='radio'  className='mr-[8px]' onClick={handleWrongAnswer}></input>  C.	超連結三︰<div className='text-blue-500 underline cursor-pointer' onClick={handleWrongAnswer}>熱門角色介紹</div>
        </div>
         <div className='w-full text-left flex flex-row'>
          <input type='radio' className='mr-[8px]' onClick={(e) => { e.preventDefault(); setShowAnswer1Popup(true) }}></input>  D.	超連結四︰<div className='text-blue-500 underline cursor-pointer' onClick={(e) => { e.preventDefault(); setShowAnswer1Popup(true) }}>樂園地圖</div>
        </div>
        <br />

        {showAnswer1Popup && (
          <div className='w-full h-full absolute inset-0 bg-[#00000080] p-4 flex items-center justify-center'>
            <div className='bg-white p-4 rounded flex flex-col'>
              答案︰D
              <br />
              解析：小美想知道「小小世界」在哪裏，最需要的是能幫她找位置的資料。選項 D「樂園地圖」可以告訴她設施在哪個位置，最有用。其他選項(餐飲推薦、表演時間表和熱門角色介紹)，和找「小小世界」的位置沒有關係。

              <button onClick={() => setShowAnswer1Popup(false)} className='mt-4 bg-blue-500 text-white p-2 rounded'>關閉</button>
            </div>
          </div>
        )}
        <br />
        <br /><br />
        <div className='w-full'>
          2.	小文讀完網頁後，想觀賞文中提到「2016年由動畫大師繪製、在電影院放映並獲得全球好評的皮影動畫片」。以下四個超連結，點選哪一個最有用？
        </div>
       <div className='w-full text-left flex flex-row'>
          <input type='radio'  className='mr-[8px]' onClick={handleWrongAnswer} ></input>  A.	超連結一︰<div className='text-blue-500 underline cursor-pointer' onClick={handleWrongAnswer}>漢朝漢武帝與李夫人的愛情故事</div>
        </div>
        <div className='w-full text-left flex flex-row'>
          <input type='radio'  className='mr-[8px]' onClick={handleWrongAnswer} ></input>  B.	超連結二︰<div className='text-blue-500 underline cursor-pointer' onClick={handleWrongAnswer}>傳統皮偶的雕刻與上色手工藝</div>
        </div>
        <div className='w-full text-left flex flex-row'>
          <input type='radio'  className='mr-[8px]' onClick={(e) => { e.preventDefault(); setShowAnswer2Popup(true) }}></input>  C.	超連結三︰<div className='text-blue-500 underline cursor-pointer' onClick={(e) => { e.preventDefault(); setShowAnswer2Popup(true) }}>首部皮影動畫電影線上看</div>
        </div>
         <div className='w-full text-left flex flex-row'>
          <input type='radio' className='mr-[8px]' onClick={handleWrongAnswer}></input>  D.	超連結四︰<div className='text-blue-500 underline cursor-pointer' onClick={handleWrongAnswer}>如何利用三枝竹竿操控皮偶動作</div>
        </div>
        <br />

       
        <br />

        <br />

        {showAnswer2Popup && (
          <div className='w-full h-full absolute inset-0 bg-[#00000080] p-4 flex items-center justify-center'>
            <div className='bg-white p-4 rounded flex flex-col'>
              答案︰C
              <br />
             解析：題目要找「觀賞2016年的皮影動畫片」，選項 C 提到的「首部皮影動畫電影線上看（觀賞影片）」最符合需求。其他選項（愛情故事、雕刻手工藝、操控皮偶動作）均與觀賞該動畫片無關。

              <button onClick={() => setShowAnswer2Popup(false)} className='mt-4 bg-blue-500 text-white p-2 rounded'>關閉</button>
            </div>
          </div>
        )}

      </div>

      {/* return button*/}
      <button onClick={props.onClose} className='my-[24px] bg-blue-500 text-white p-2 px-[16px] rounded'>返回</button>
    </div>
  )
}

export default connect((store) => {
  return {
    token: store.tokenReducer,
  }
})(Component)
